import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Input,
} from "@angular/core";
import {
  Validators,
  FormControl,
  FormGroup,
  FormBuilder,
  UntypedFormGroup,
} from "@angular/forms";
import {
  DataService,
  Dialog,
  SharedModule,
  NotificationService,
  ModalService,
  GetPromotionListQuery,
  findTranslation,
  LanguageCode,
  ServerConfigService,
} from "@bb-vendure/admin-ui/core";
import {
  Observable,
  of,
  Subject,
  concat,
  tap,
  take,
  switchMap,
  debounceTime,
  distinctUntilChanged,
  map,
  shareReplay,
  combineLatest,
  takeUntil,
} from "rxjs";
import {
  ActivatedRoute,
  ActivationStart,
  ResolveFn,
  Router,
} from "@angular/router";
import { CreateCorporateDiscountDocument, UpdateCorporateDiscountDocument } from "src/generated-gql/graphql";

@Component({
  standalone: true,
  imports: [SharedModule],
  templateUrl: "./cdt-dialog.component.html",
  styleUrl: "./cdt-dialog.component.scss",
  changeDetection: ChangeDetectionStrategy.Default,
})
export class CorperateDiscountDialogComponent implements OnInit, Dialog<any> {
  constructor(
    private dataService: DataService,
    private formBuilder: FormBuilder,
    private notificationService: NotificationService,
    private modalService: ModalService,
    private route: ActivatedRoute,
    private router: Router,
    private serverConfigService: ServerConfigService
  ) {}

  @Input()
  productId: string;

  @Input()
  entity: any;

  currentTitle: string;

  artists$: Observable<GetPromotionListQuery["promotions"]["items"]>;

  languageCode$: Observable<LanguageCode>;
  languageCode: LanguageCode;

  availableLanguages$: Observable<LanguageCode[]>;

  protected destroy$ = new Subject<void>();

  destroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setLanguage(code: LanguageCode) {
    this.setQueryParam("lang", code);
    this.dataService.client.setContentLanguage(code).subscribe();
  }

  canDeactivate(): boolean {
    return this.detailForm && this.detailForm.pristine;
  }

  detailForm = this.formBuilder.group({
    quantity: [0, Validators.required],
    percent: [0, Validators.required]
  });

  ngOnInit(): void {
    // console.log(this.entity)
    // this.languageCode$ = this.route.queryParams.pipe(
    //   map(queryParams => queryParams.lang),
    //   switchMap(lang => {
    //     if (lang) {
    //       return of(lang as LanguageCode);
    //     } else {
    //       return this.dataService.client
    //         .uiState()
    //         .mapSingle(data => data.uiState.contentLanguage);
    //     }
    //   }),
    //   distinctUntilChanged(),
    //   tap(val => (this.languageCode = val)),
    //   shareReplay(1)
    // );
    // this.availableLanguages$ = this.serverConfigService.getAvailableLanguages();

    // combineLatest([this.languageCode$])
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe(([languageCode]) => {
    //     if (this.entity) {
    //       this.setFormValues(languageCode);
    //     }
    //     this.detailForm.markAsPristine();
    //   });
    this.setFormValues();
  }

  resolveWith: (result?: any) => void;

  private setFormValues() {
    this.detailForm.patchValue({
      ...this.entity,
    });
  }

  save() {
    const { quantity, percent } =
      this.detailForm.value;

    this.dataService
      .mutate(CreateCorporateDiscountDocument, {
        input: {
          productId: this.productId,
          quantity: quantity!,
          percent: percent! 
        },
      })
      .subscribe(({ createCorporateDiscount }) => {
        if (createCorporateDiscount.id) {
          this.notificationService.success("Created.");
          this.resolveWith(createCorporateDiscount);
        }
      });
  }

  update() {
    const { quantity, percent } =
      this.detailForm.value;

    this.dataService
      .mutate(UpdateCorporateDiscountDocument, {
        input: {
          id: this.entity.id,
          quantity: quantity!,
         percent: percent! 
        },
      })
      .subscribe(({ updateCorporateDiscount }) => {
        if (updateCorporateDiscount!.id) {
          this.notificationService.success("Updated.");
          this.resolveWith(updateCorporateDiscount);
        }
      });
  }

  cancel() {
    this.resolveWith(null);
  }

  protected setQueryParam(key: string, value: any) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { ...this.route.snapshot.queryParams, [key]: value },
      queryParamsHandling: "merge",
    });
  }
}
